<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="90" inline>
        <FormItem label="客户端SN码">
          <Input class="mb-2" placeholder="请输入" v-model="table.search.ClientSN"></Input>
        </FormItem>
        <FormItem label="类型">
          <Select placeholder="请选择" v-model="table.search.ClientLogType" clearable>
            <Option
              v-for="(item, index) in clientLogTypeSelect"
              :value="item.value"
              :key="index"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="错误码">
          <Input placeholder="请输入" v-model="table.search.ClientLogCode"></Input>
        </FormItem>
        <FormItem label="日志标题">
          <Input placeholder="请输入" v-model="table.search.ClientLogTitle"></Input>
        </FormItem>
        <FormItem label="开始时间">
            <DatePicker
              type="date"   
              @on-change="table.search.StartTime=$event"
              v-model="table.search.StartTime"
              placeholder="选择开始时间"
            ></DatePicker>
        </FormItem>
        <FormItem label="结束时间">
            <DatePicker
              type="date"
              @on-change="table.search.EndTime=$event"
              v-model="table.search.EndTime"
              placeholder="选择结束时间"
            ></DatePicker>
        </FormItem>
        <Button class="ml-5" type="success" @click="search">查询</Button>
      </Form>
      <div></div>
    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
    ></DataTable>

      <!-- @selectionChange="selectionChange" -->
    <!--详情-->
    <Modal
      v-model="detailModal"
      title="日志详情"
      :footer-hide="true"
      
      :closable="false"
      width="60%"
    >
      <logDetail
        v-if="detailModal"
        @close="detailModal = false"
        :currentData="currentData"
      ></logDetail>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import logDetail from "../clientlog/detail.vue";

export default {
  components: { DataTable, logDetail },
  data: function () {
    return {
      EmailSendFlagSelect: [],
      currentData: {},
      detailModal: false,
      table: {
        columns: [
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "客户端SN码", key: "clientSN", width: "120px" },
          {
            title: "类型",
            key: "clientLogType",
            width: "80px",
            render: (h, value) => {
              return h(
                "div",
                this.$common.getEnumDescription(
                  "clientLogType",
                  value.row.clientLogType
                )
              );
            },
          },
          { title: "错误码", key: "clientLogCode", width: "120px" },
          { title: "日志标题", key: "clientLogTitle" },
          { title: "创建时间", key: "clientLogDate", width: "150px" },

          {
            title: "操作",
            width: "80px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
              ]);
            },
          },
        ],
        apiUrl: "log/getClientLogList",
        search: {
          ClientSN: "",
          ClientLogType: "",
          ClientLogCode: "",
          ClientLogTitle: "",
          StartTime: "",
          EndTime: "",
        },
      },
    };
  },

  created: function () {
    this.clientLogTypeSelect = this.$common.getJsonData("clientLogType");
  },
  activated(){
    this.search()
  },
  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = data;
    },
  },
};
</script>
<style scoped>
</style>